import { onMounted, onUnmounted, ref } from 'vue';
import { Network, type ConnectionStatus } from '@capacitor/network';
import type { PluginListenerHandle } from '@capacitor/core';

export function useNetworkStatus() {
  const isOnline = ref(true);
  let listenerHandle: PluginListenerHandle | undefined;

  const applyStatus = (status: ConnectionStatus) => {
    isOnline.value = status.connected;
  };

  onMounted(async () => {
    applyStatus(await Network.getStatus());
    listenerHandle = await Network.addListener(
      'networkStatusChange',
      applyStatus
    );
  });

  onUnmounted(() => {
    listenerHandle?.remove();
  });

  return { isOnline };
}
